var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n    <div class=\"leaflet-popup-header\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Nome") : depth0), depth0))
    + "</div>\n    <div class=\"leaflet-popup-image\"></div>\n    <div class=\"leaflet-popup-address\">\n        <span class=\"leaflet-popup-address-title\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.Group",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":5,"column":50},"end":{"line":5,"column":73}}}))
    + ":</span>\n        <span class=\"leaflet-popup-address-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Grupo") : depth0), depth0))
    + "</span>\n        <br />\n        <span class=\"leaflet-popup-address-title\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.Address",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":50},"end":{"line":8,"column":75}}}))
    + ":</span>\n        <span class=\"leaflet-popup-address-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Logradouro") : depth0), depth0))
    + "</span>\n        <br />\n        <span class=\"leaflet-popup-address-title\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.City",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":11,"column":50},"end":{"line":11,"column":72}}}))
    + ":</span>\n        <span class=\"leaflet-popup-address-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Municipio") : depth0), depth0))
    + "</span>\n        <br />\n        <span class=\"leaflet-popup-address-title\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.State",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":50},"end":{"line":14,"column":73}}}))
    + ":</span>\n        <span class=\"leaflet-popup-address-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"UF") : depth0), depth0))
    + "</span>\n        <br />\n        <span class=\"leaflet-popup-address-title\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.Type",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":17,"column":50},"end":{"line":17,"column":72}}}))
    + ":</span>\n        <span class=\"leaflet-popup-address-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"TipoLojaNaoHomologadaNome") : depth0), depth0))
    + "</span>\n        <br />\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-unapproved-stores-popup.hbs
// module id = NkSD
// module chunks = 1